export const holidays = [
  "08-15-2025",
  "08-27-2025",
  "10-02-2025",
  "10-21-2025",
  "10-22-2025",
  "11-5-2025",
  "12-25-2025",
];

export const lotSize: any = {
  NIFTY: 50,
  FINNIFTY: 40,
  BANKNIFTY: 25,
};
